import React from 'react';
import PropTypes from 'prop-types';
import LoaderSpinner from '../../common/Loader';
import TaskInvoiceActions from './TaskInvoiceActions';
import { formatInvoiceAmount, formatInvoiceDate } from '../../../utils/taskInvoice';

// Read-only list of task invoices: number, date, description, amount, PDF / Print.
const TaskInvoicesTable = ({ invoices, loading = false, emptyText = 'No invoices found' }) => (
    <div className="table-responsive main_content_table_history tableFixHead muiCollapsibleTable noBorder">
        <table className="table">
            <thead>
                <tr>
                    <th>Invoice #</th>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Invoice</th>
                </tr>
            </thead>
            <tbody>
                {loading && (
                    <tr>
                        <td colSpan={5} className="text-center"><LoaderSpinner /></td>
                    </tr>
                )}
                {!loading && invoices.length === 0 && (
                    <tr>
                        <td colSpan={5} className="text-center">{emptyText}</td>
                    </tr>
                )}
                {!loading && invoices.map((invoice) => (
                    <tr key={invoice.chargeId}>
                        <td>{invoice.invoiceNumber}</td>
                        <td>{formatInvoiceDate(invoice.invoiceDate)}</td>
                        <td className="taskComment">{invoice.description}</td>
                        <td>{formatInvoiceAmount(invoice.amount)}</td>
                        <td><TaskInvoiceActions invoice={invoice} /></td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

TaskInvoicesTable.propTypes = {
    invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool,
    emptyText: PropTypes.string,
};

export default TaskInvoicesTable;
